import React from 'react'
import classNames from 'classnames'
import DocumentMeta from 'react-document-meta'

export const Page = ({ title, className, children }) => (
  <DocumentMeta title={ `${title} - Youcan Fitness Factory` }>
    <div className={ classNames('page', className) }>
      { children }
    </div>
  </DocumentMeta>
)



// WEBPACK FOOTER //
// ./src/ui/elements/Page.js